import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

interface ProtectedRouteProps {
  component: React.ComponentType<any>;
  path: string;
  exact?: boolean;
  requireAuth?: boolean; // true = requires authentication, false = requires no authentication
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  component: Component,
  requireAuth = true,
  ...rest
}) => {
  const { isAuthenticated, loading } = useAuth();

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        if (requireAuth) {
          // Route requires authentication
          if (isAuthenticated) {
            return <Component {...props} />;
          }

          localStorage.setItem(
            "redirect_path",
            props.location.pathname + props.location.search
          );
          if (props.location.state) {
            localStorage.setItem(
              "redirect_state",
              JSON.stringify(props.location.state)
            );
          }
          return <Redirect to="/login" />;
        } else {
          // Route requires NO authentication (login/signup pages)
          return !isAuthenticated ? (
            <Component {...props} />
          ) : (
            <Redirect to="/dashboard" />
          );
        }
      }}
    />
  );
};

export default ProtectedRoute;
